$(window).on('load', initSocialWall);
$(window).on('restUpdatedItems', refreshSocialWall);

var $grid = $('.grid');

function initSocialWall() {   
    $grid.masonry({
        itemSelector: '.grid-item',
        percentPosition: true
    });
};

function refreshSocialWall() {
    if ($grid.data('masonry')) {
        $grid.masonry('reloadItems');
        $grid.masonry('layout');
    } else {
        initSocialWall();
    }    
};